import {DataPlugin, DisplayData, DisplayDataWidget} from "@me8eon/data";
import {KBArticlesDisplay, SimpleKBArticlesOneLineDisplay, SimpleKBArticlesWidget } from "./simple.kb.articles.display";

export const KBArticlesDataName = 'kb_articles';
export type KBArticlesData = {
    id: string;
    url: string;
    kb_category: string;
    sys_updated_on: string;
    type: string;
    short_description: string;
    text: string;
    index: string[];
}

export function KBArticlesDataPlugin(
    DisplayData: DisplayData<KBArticlesData> = KBArticlesDisplay,
    DisplayDataOneLine: DisplayData<KBArticlesData> = SimpleKBArticlesOneLineDisplay,
    DisplayDataWidget: DisplayDataWidget<KBArticlesData> = SimpleKBArticlesWidget): DataPlugin<KBArticlesData> {
    return {
        plugin: 'data',
        name: KBArticlesDataName,
        DisplayData,
        DisplayDataOneLine,
        DisplayDataWidget,
        idFrom: data => `${data.index}.${data.id}`
    };
}
